import {z} from 'src/lib'
import {OperacionLCLSFields, OperacionLCLSCuentaFields} from './fields'
import {schemaEntityWithId} from 'src/types'

export const schemaFormOperacionLCLSCuenta = z.object({
    [OperacionLCLSCuentaFields.NroCuenta]: z.string({required_error: 'El Nro. de Cuenta es requerido.'}).min(1, 'El Nro. de Cuenta es requerido.'),
    [OperacionLCLSCuentaFields.RazonSocial]: z.string({required_error: 'La Razón Social es requerida.'}).min(1, 'La Razón Social es requerida.'),
    [OperacionLCLSCuentaFields.Moneda]: z.string({required_error: 'La Moneda es requerida.'}).min(1, 'La Moneda es requerida.'),
    [OperacionLCLSCuentaFields.CodClienteTipo]: z.number({required_error: 'El Tipo de Cliente es requerido.'}),
    [OperacionLCLSCuentaFields.CodClienteSubTipo]: z.number().nullable(),
    [OperacionLCLSCuentaFields.DescClienteTipo]: z.string().optional(),
    [OperacionLCLSCuentaFields.DescClienteSubTipo]: z.string().optional(),
    [OperacionLCLSCuentaFields.LimiteConcertacion]: z.preprocess(
        (val) => (val === '' ? null : val),
        z.coerce.number({invalid_type_error: 'El límite debe ser un número.'})
    ),
    [OperacionLCLSCuentaFields.LimiteLiquidacionDVP]: z.preprocess(
        (val) => (val === '' ? null : val),
        z.coerce.number({invalid_type_error: 'El límite debe ser un número.'})
    ),
    [OperacionLCLSCuentaFields.LimiteLiquidacionFOP]: z.preprocess(
        (val) => (val === '' ? null : val),
        z.coerce.number({invalid_type_error: 'El límite debe ser un número.'})
    ),
    _subTiposDisponibles: z.boolean().optional()
})
    .refine(
        (data) => {
            if (data._subTiposDisponibles && data[OperacionLCLSCuentaFields.CodClienteSubTipo] == null) {
                return false;
            }

            return true;
        },
        {
            message: 'El Subtipo de Cliente es requerido.',
            path: [OperacionLCLSCuentaFields.CodClienteSubTipo],
        }
    );

export type FormOperacionLCLSCuenta = z.infer<typeof schemaFormOperacionLCLSCuenta>;

export const schemaFormOperacionLCLS = z
    .object({
            [OperacionLCLSFields.CodPais]: z.number({required_error: 'El país es requerido.'}),
            [OperacionLCLSFields.CodUnidadNegocio]: z.number({required_error: 'La unidad de negocio es requerida.'}),
            [OperacionLCLSFields.CodSectorComercial]: z.coerce.number({invalid_type_error: 'El sector comercial es requerido.'}).min(1, {message: 'El sector comercial es requerido.'}),
            [OperacionLCLSFields.FechaSolicitud]: z.date({required_error: 'La fecha de solicitud es requerida.'}),
            [OperacionLCLSFields.FechaVencimiento]: z.date({required_error: 'La fecha de vencimiento es requerida.'}),
            [OperacionLCLSFields.Observaciones]: z.string().optional().nullable(),

            [OperacionLCLSFields.Cuentas]: z.array(schemaFormOperacionLCLSCuenta)
                .min(1, { message: 'Debe agregar al menos una cuenta.' }),
    })
    .refine(
        (schema) => {
                if (schema.fechaVencimiento && schema.fechaSolicitud) {
                        return schema.fechaVencimiento.getTime() >= schema.fechaSolicitud.getTime();
                }

                return true;
        },
        {
                message: 'La fecha de vencimiento debe ser mayor a la fecha de solicitud.',
                path: [OperacionLCLSFields.FechaVencimiento],
        }
    );

export type FormOperacionLCLS = z.infer<typeof schemaFormOperacionLCLS>

export const schemaOperacionLCLS = z
    .object({
            [OperacionLCLSFields.CodOperacionLCLS]: z.number(),
            [OperacionLCLSFields.CodPais]: z.number(),
            [OperacionLCLSFields.NombrePais]: z.string(),
            [OperacionLCLSFields.CodUnidadNegocio]: z.number(),
            [OperacionLCLSFields.DescUnidadNegocio]: z.string(),
            [OperacionLCLSFields.CodSectorComercial]: z.number(),
            [OperacionLCLSFields.DescSectorComercial]: z.string(),
            [OperacionLCLSFields.FechaSolicitud]: z.coerce.date(),
            [OperacionLCLSFields.FechaVencimiento]: z.coerce.date(),
            [OperacionLCLSFields.CodEstado]: z.number(),
            [OperacionLCLSFields.DescEstado]: z.string(),
            [OperacionLCLSFields.FechaAprobacion]: z.coerce.date().nullable(),
            [OperacionLCLSFields.FechaAlta]: z.coerce.date().nullable(),
            [OperacionLCLSFields.IdUsuarioAlta]: z.number(),
            [OperacionLCLSFields.NombreUsuarioAlta]: z.string(),
            [OperacionLCLSFields.ApellidoUsuarioAlta]: z.string(),

            [OperacionLCLSFields.Observaciones]: z.string().nullable(),
            [OperacionLCLSFields.EstadoFinalizado]: z.boolean(),
            [OperacionLCLSFields.PermiteEditarOperacion]: z.boolean(),
            [OperacionLCLSFields.PermiteEliminarOperacion]: z.boolean(),
    })
    .merge(schemaEntityWithId)

export type OperacionLCLS = z.infer<typeof schemaOperacionLCLS>